import { render, staticRenderFns } from "./ComptrollerReportV5.vue?vue&type=template&id=667720a4&scoped=true"
import script from "./ComptrollerReportV5.vue?vue&type=script&lang=js"
export * from "./ComptrollerReportV5.vue?vue&type=script&lang=js"
import style0 from "./ComptrollerReportV5.vue?vue&type=style&index=0&id=667720a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667720a4",
  null
  
)

export default component.exports